export default __webpack_public_path__ + "67d5f62.png";